import { Columns } from "../../mp-shared-components/generic-shared-components/components"
import { ManagePages } from "../types"

export interface TableOptions {
  headerColumns: Columns[]
  displayedProperties: string[]
  allDisplayedProperties?: string[]
}

export const getTableOptions = (page: ManagePages): TableOptions => {
  const UsersTableHeaderColumns: Columns[] = [
    {
      label: "First Name",
      name: "firstName",
      propertyId: "firstName",
      sortable: true
    },
    {
      label: "Last Name",
      name: "lastName",
      propertyId: "lastName",
      sortable: true
    },
    { label: "Email", name: "email", propertyId: "email", sortable: true },
    {
      label: "Username",
      name: "username",
      propertyId: "username",
      sortable: true
    },
    {
      label: "Created",
      name: "created",
      propertyId: "created",
      sortable: true
    },
    {
      label: "Created by",
      name: "createdByAdminName",
      propertyId: "createdByAdminName",
      sortable: true
    },
    { label: "Logins", name: "logins", propertyId: "logins", sortable: true },
    {
      label: "Last Login",
      name: "lastLogin",
      propertyId: "lastLogin",
      sortable: true
    }
  ]

  const UsersTableDisplayedProperties = [
    "firstName",
    "lastName",
    "email",
    "username",
    "createdDate",
    "createdByAdminName",
    "logins",
    "lastLoginDate"
  ]

  switch (page) {
    case ManagePages.Districts:
      return {
        headerColumns: [
          { label: "Name", name: "name", propertyId: "name", sortable: true },
          {
            label: "State",
            name: "state",
            propertyId: "state",
            sortable: true
          },
          {
            label: "Admins",
            name: "adminsCount",
            propertyId: "adminsCount",
            sortable: true
          },
          {
            label: "Schools",
            name: "schoolsCount",
            propertyId: "schoolsCount",
            sortable: true
          },
          {
            label: "Created",
            name: "created",
            propertyId: "created",
            sortable: true
          },
          {
            label: "Created by",
            name: "createdByAdminName",
            propertyId: "createdByAdminName",
            sortable: true
          }
        ],
        displayedProperties: [
          "name",
          "state",
          "adminsCount",
          "schoolsCount",
          "createdDate",
          "createdByAdminName"
        ]
      }
    case ManagePages.DistrictAdmins:
    case ManagePages.SchoolAdmins:
      return {
        headerColumns: UsersTableHeaderColumns,
        displayedProperties: UsersTableDisplayedProperties
      }

    case ManagePages.Teachers:
      // Commented out, because now we don't have classes count in teachers data
      // UsersTableHeaderColumns.push({
      //   label: "Classes",
      //   name: "classesCount",
      //   propertyId: "classesCount",
      //   sortable: true
      // })
      // UsersTableDisplayedProperties.push("classesCount")
      return {
        headerColumns: UsersTableHeaderColumns,
        displayedProperties: UsersTableDisplayedProperties
      }

    case ManagePages.Schools:
      return {
        headerColumns: [
          { label: "Name", name: "name", propertyId: "name", sortable: true },
          {
            label: "Created",
            name: "created",
            propertyId: "created",
            sortable: true
          },
          {
            label: "Created by",
            name: "createdByAdminName",
            propertyId: "createdByAdminName",
            sortable: true
          },
          {
            label: "Students",
            name: "studentsCount",
            propertyId: "studentsCount",
            sortable: true
          },
          // {
          //   label: "Active Students",
          //   name: "activeStudentsCount",
          //   propertyId: "activeStudentsCount",
          //   sortable: true
          // },
          {
            label: "Teachers",
            name: "teachersCount",
            propertyId: "teachersCount",
            sortable: true
          },
          {
            label: "Active Teachers",
            name: "activeTeachersCount",
            propertyId: "activeTeachersCount",
            sortable: true
          }
        ],
        displayedProperties: [
          "name",
          "createdDate",
          "createdByAdminName",
          "studentsCount",
          "activeStudentsCount",
          "teachersCount",
          "activeTeachersCount"
        ]
      }

    case ManagePages.Classes:
      return {
        headerColumns: [
          {
            label: "Name",
            name: "className",
            propertyId: "className",
            sortable: true
          },
          {
            label: "Period",
            name: "period",
            propertyId: "period",
            sortable: true
          },
          {
            label: "Grade",
            name: "grades",
            propertyId: "grades"
          },
          {
            label: "Teacher",
            name: "teacherName",
            propertyId: "teacherName",
            sortable: true
          },
          {
            label: "School",
            name: "schoolName",
            propertyId: "schoolName",
            sortable: true
          },
          {
            label: "Subject",
            name: "subject",
            propertyId: "subject",
            sortable: true
          },
          {
            label: "MasteryPrep Course",
            name: "eocSubjects",
            propertyId: "eocSubjects"
          },
          {
            label: "Course Code",
            name: "courseCode",
            propertyId: "courseCode",
            sortable: true
          },
          {
            label: "Created",
            name: "createdAt",
            propertyId: "createdAt",
            sortable: true
          },
          {
            label: "Created by",
            name: "createdBy",
            propertyId: "createdBy",
            sortable: true
          },
          {
            label: "Students",
            name: "studentCount",
            propertyId: "studentCount",
            sortable: true
          }
          // {
          //   label: "Active Students",
          //   name: "activeStudentsCount",
          //   propertyId: "activeStudentsCount"
          // }
        ],
        displayedProperties: [
          "className",
          "period",
          "teacherName",
          "schoolName",
          "eocSubjects",
          "createdAt",
          "createdBy",
          "studentCount"
          //"activeStudentsCount"
        ],
        allDisplayedProperties: [
          "name",
          "period",
          "grade",
          "teacherName",
          "subject",
          "eocSubjects",
          "courseCode",
          "createdAt",
          "createdBy",
          "studentsCount"
          //"activeStudentsCount"
        ]
      }

    case ManagePages.Students:
      return {
        headerColumns: UsersTableHeaderColumns,
        displayedProperties: UsersTableDisplayedProperties
      }

    default:
      return { headerColumns: [], displayedProperties: [] }
  }
}
